module.exports = __webpack_public_path__ + "img/providers-bg.e698c7c3.jpg";